// Storage quota DTO (plan.md §6.5).
import { z } from 'zod';
export const StorageQuota = z.object({
    userId: z.string().uuid(),
    /** Hard ceiling for this user's non-deleted files. */
    bytesLimit: z.number().int().nonnegative(),
    /** Live aggregate of size_bytes across non-deleted files. Computed
     *  per-request — not denormalised. */
    bytesUsed: z.number().int().nonnegative(),
    /** Free-form admin label — 'default', 'plus', 'pro'. */
    tier: z.string().min(1).max(64),
    updatedAt: z.string().datetime({ offset: true }),
});
/** Optional dashboard projection — type distribution + totals. The
 *  SPA renders the file-type pie chart from `byKind`. */
export const StorageDashboard = z.object({
    quota: StorageQuota,
    /** Bytes per top-level mime kind (image / video / audio / document
     *  / archive / other). */
    byKind: z.record(z.string(), z.number().int().nonnegative()),
    /** Bytes in each partition. */
    byPartition: z.record(z.string(), z.number().int().nonnegative()),
    /** Recycle-bin bytes — soft-deleted files still consume disk until
     *  the 30-day cron purges them. The SPA shows this so a quota-
     *  exhausted user can manually empty. */
    recycleBytes: z.number().int().nonnegative(),
    fileCount: z.number().int().nonnegative(),
    folderCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=quota.js.map